type UrlParams = { [key: string]: string };

const getMarketingPublicParams = (): UrlParams | null => {
    try {
        const publicParams = window.__INIT_EXP_STATE__?.publicParams;

        if (
            !publicParams ||
            typeof publicParams !== 'object' ||
            Array.isArray(publicParams) ||
            ![Object.prototype, null].includes(Object.getPrototypeOf(publicParams)) ||
            !Object.values(publicParams).every(value => typeof value === 'string')
        ) {
            return null;
        }

        return { ...publicParams };
    } catch {
        return null;
    }
};

const get = (params: string): string => {
    const publicParams = getMarketingPublicParams();

    if (publicParams !== null) {
        return Object.prototype.hasOwnProperty.call(publicParams, params)
            ? publicParams[params]
            : '';
    }

    const reg = new RegExp(`(^|&)${params}=([^&]*)(&|$)`, 'i');
    const searchR = window.location.search.substr(1).match(reg);
    let value = '';

    if (searchR !== null) {
        try {
            value = decodeURIComponent(searchR[2]);
        } catch (e) {
            value = searchR[2];
        }
    }

    if (!value) {
        const hash = window.location.hash || '';
        const hashArr: string[] = hash.split('?');

        if (hashArr.length >= 2 && hashArr[1].match(reg) !== null) {
            const hashR: RegExpMatchArray | null = hashArr[1].match(reg);

            try {
                value = decodeURIComponent(hashR ? hashR[2] : '');
            } catch (e) {
                value = hashR ? hashR[2] : '';
            }
        }
    }

    return value;
};

const parseQuery = (url: string = window.location.href) => {
    const obj: { [key: string]: string } = {};
    const arr = url.match(new RegExp('[?&][^?&]+=[^?&]+', 'g')) || [];

    if (arr.length) {
        arr.forEach((item) => {
            const pairStr = item.substring(1);
            const equalIndex = pairStr.indexOf('=');
            let key = pairStr.substring(0, equalIndex);

            try {
                key = decodeURIComponent(key);
            } catch (e) {
                console.log('decodeURIComponent error', key);
            }

            let val = pairStr.substring(equalIndex + 1, pairStr.length);

            try {
                val = decodeURIComponent(val);
            } catch (e) {
                console.log('decodeURIComponent error', key);
            }

            // 如果val包含#/手动去除

            if (val.indexOf('#/') > -1) {
                val = val.substring(0, val.indexOf('#/'));
            }

            obj[key] = val;
        });
    }

    const publicParams = getMarketingPublicParams();

    if (publicParams !== null) {
        return {
            ...publicParams,
            ...obj
        };
    }

    return obj;
};

// 不会对url参数及参数值进行decode
const pureParseQuery = (url: string = window.location.href) => {
    const publicParams = getMarketingPublicParams();
    const newObj: { [key: string]: string } = {};
    const obj: { [key: string]: string } = {};
    const arr = url.match(new RegExp('[?&][^?&]+=[^?&]+', 'g')) || [];

    if (publicParams) {
        Object.keys(publicParams).forEach((key) => {
            const value = publicParams[key];

            if (!value) {
                newObj[key] = value;

                return;
            }

            try {
                newObj[key] = encodeURIComponent(value);
            } catch {
                newObj[key] = value;
            }
        });
    }

    if (arr.length) {
        arr.forEach((item) => {
            const pairStr = item.substring(1);
            const equalIndex = pairStr.indexOf('=');
            const key = pairStr.substring(0, equalIndex);
            let val = pairStr.substring(equalIndex + 1, pairStr.length);

            // 如果val包含#/手动去除
            if (val.indexOf('#/') > -1) {
                val = val.substring(0, val.indexOf('#/'));
            }

            obj[key] = val;
        });
    }

    return {
        ...newObj,
        ...obj
    };
};

type QueryParams = {
    [key: string]: string | number | boolean | undefined;
};

const buildUrl = (url: string, queryParams?: QueryParams): string => {
    if (!queryParams) {
        return url;
    }

    const queryParts: string[] = [];

    Object.keys(queryParams).forEach(key => {
        const value = queryParams[key];

        if (value !== undefined && value !== '') { // 只添加非undefined的值
            queryParts.push(`${key}=${String(value)}`);
        }
    });

    if (queryParts.length > 0) {
        const newUrl = url + (url.includes('?') ? '&' : '?') + queryParts.join('&');

        return newUrl;
    }

    return url;
};

export default {
    get,
    parseQuery,
    buildUrl,
    pureParseQuery
};
